import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({
  settings: {
    calendly_url: "",
    speaking_calendly_url: "",
    mailchimp_action_url: "",
    public_contact_email: "consult@wanakeetrask.com",
    instagram_url: "",
    linkedin_url: "",
    facebook_url: "",
  },
  loading: true,
  refresh: async () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    calendly_url: "",
    speaking_calendly_url: "",
    mailchimp_action_url: "",
    public_contact_email: "consult@wanakeetrask.com",
    instagram_url: "",
    linkedin_url: "",
    facebook_url: "",
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings((prev) => ({ ...prev, ...data }));
    } catch (e) {
      // Keep defaults silently.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
